import React, { FC } from 'react';

// components
import { FormSectionTextInput } from '../FormSectionTextInput';

import { FormSectionNameFieldsProps } from './FormSectionNameFields.types';

const FormSectionNameFields: FC<FormSectionNameFieldsProps> = ({
  formData,
  register,
  errors,
  className,
  fieldClassName,
  labelClassName,
  inputClassName,
  usePlaceholderLabels = false,
}) => {
  return (
    <div className={className ? `full ${className}` : ' full'}>
      <div className='grid-x form-group full'>
        <div className='cell small-12 medium-6'>
          <FormSectionTextInput
            data={formData.firstName}
            register={register}
            errors={errors}
            required
            className={fieldClassName}
            labelClassName={labelClassName}
            inputClassName={inputClassName}
            placeholder={
              usePlaceholderLabels ? formData.firstName.label : undefined
            }
            isDarkMode={usePlaceholderLabels ? false : undefined}
          />
        </div>
        <div className='cell small-12 medium-6'>
          <FormSectionTextInput
            data={formData.lastName}
            register={register}
            errors={errors}
            required
            className={fieldClassName}
            labelClassName={labelClassName}
            inputClassName={inputClassName}
            placeholder={
              usePlaceholderLabels ? formData.lastName.label : undefined
            }
            isDarkMode={usePlaceholderLabels ? false : undefined}
          />
        </div>
      </div>
    </div>
  );
};

export default FormSectionNameFields;
